'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CurrentArticle = exports.CurrentArticleProvider = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBroadcast = require('react-broadcast');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CURRENT_ARTICLE_CHANNEL = 'currentArticleChannel';

var CurrentArticleProvider = function CurrentArticleProvider(_ref) {
    var article = _ref.article,
        props = (0, _objectWithoutProperties3.default)(_ref, ['article']);
    return _react2.default.createElement(_reactBroadcast.Broadcast, (0, _extends3.default)({}, props, { channel: CURRENT_ARTICLE_CHANNEL, value: article }));
};
CurrentArticleProvider.propTypes = {
    children: _propTypes2.default.node.isRequired,
    article: _propTypes2.default.shape({}).isRequired
};

var CurrentArticle = function CurrentArticle(props) {
    return _react2.default.createElement(_reactBroadcast.Subscriber, (0, _extends3.default)({}, props, { channel: CURRENT_ARTICLE_CHANNEL }));
};

CurrentArticle.propTypes = {
    children: _propTypes2.default.func.isRequired
};

exports.CurrentArticleProvider = CurrentArticleProvider;
exports.CurrentArticle = CurrentArticle;
//# sourceMappingURL=CurrentArticle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/component-context/lib/cjs/CurrentArticle.js
 ** module id = 265
 ** module chunks = 1
 **/